module.exports = __webpack_public_path__ + "static/img/research-bg.3112a5bd.png";